import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = { class: "map" }
const _hoisted_5 = { class: "map_addr" }
const _hoisted_6 = { style: {"display":"inline-flex","align-items":"center"} }
const _hoisted_7 = { style: {"display":"inline-flex","align-items":"center"} }
const _hoisted_8 = { style: {"display":"inline-flex","align-items":"center"} }
const _hoisted_9 = { style: {"display":"inline-flex","align-items":"center"} }

import { ref } from "vue";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/page/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { NIcon } from "naive-ui";
import { LocationSharp, Call, Print, MailSharp } from "@vicons/ionicons5";


export default /*@__PURE__*/_defineComponent({
  __name: 'Sub6',
  setup(__props) {

const isOpen = ref(false);

// 토글 함수
function toggleRow() {
  isOpen.value = !isOpen.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "etc",
      subtitle: "etc",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("오시는 길"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "location" }, [
            _createElementVNode("iframe", {
              src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3212.364770575075!2d127.3897800765489!3d36.37616267237103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x356549915464da7d%3A0x4058b6419f83a138!2z7Juw7Lig7YOA7JuM!5e0!3m2!1sko!2skr!4v1749720495619!5m2!1sko!2skr",
              width: "600",
              height: "450",
              style: {"border":"0"},
              allowfullscreen: "",
              loading: "lazy",
              referrerpolicy: "no-referrer-when-downgrade"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("dl", null, [
              _createElementVNode("dt", _hoisted_6, [
                _createVNode(_unref(NIcon), {
                  size: "16",
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(LocationSharp))
                  ]),
                  _: 1
                }),
                _cache[0] || (_cache[0] = _createTextVNode(" 주소 "))
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("dd", null, " 대전 유성구 엑스포로123번길 27-22 (도룡동) KCC 웰츠타워 101동 1107호 ", -1))
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", _hoisted_7, [
                _createVNode(_unref(NIcon), {
                  size: "16",
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Call))
                  ]),
                  _: 1
                }),
                _cache[2] || (_cache[2] = _createTextVNode(" 전화번호 "))
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("dd", null, "042-867-5558", -1))
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", _hoisted_8, [
                _createVNode(_unref(NIcon), {
                  size: "16",
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Print))
                  ]),
                  _: 1
                }),
                _cache[4] || (_cache[4] = _createTextVNode("팩스 "))
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("dd", null, "042-867-7228", -1))
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", _hoisted_9, [
                _createVNode(_unref(NIcon), {
                  size: "16",
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MailSharp))
                  ]),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createTextVNode(" 이메일 "))
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("dd", null, "admin@cokolab.com", -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})